import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { AgentRuntimeHarness } from './AgentRuntimeHarness'
import { App } from './App'
import './styles.css'

const runtimeMode = new URLSearchParams(window.location.search).get('runtime')

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {runtimeMode === 'agent' ? <AgentRuntimeHarness /> : <App />}
  </StrictMode>,
)
